/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Polish_Title6Inputs */

const en_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform-grade polish`)
};

const ar_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صقل بمستوى المنصة`)
};

const bn_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্ম-গ্রেড পলিশ`)
};

const de_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politur in Plattformqualität`)
};

const es_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulido para plataformas`)
};

const fr_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polissage de qualité plateforme`)
};

const pt_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polimento de nível de plataforma`)
};

const zh_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台级抛光`)
};

const tr_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform düzeyinde cila`)
};

const ru_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полировка платформенного уровня`)
};

const pl_svc_mobile_app_development_polish_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Polish_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politura klasy platformowej`)
};

/**
* | output |
* | --- |
* | "Platform-grade polish" |
*
* @param {Svc_Mobile_App_Development_Polish_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_polish_title6 = /** @type {((inputs?: Svc_Mobile_App_Development_Polish_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Polish_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_polish_title6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_polish_title6(inputs)
	return en_svc_mobile_app_development_polish_title6(inputs)
});
export { svc_mobile_app_development_polish_title6 as "svc_mobile-app-development_POLISH_title" }